import React from 'react'
import { useChartJS } from 'hooks/chart/use-chart'
import { getPerformanceLineConfig } from './performance-line-config'
import { ChartPlot } from 'pages/portfolio/storage/interface'

interface Props {
  data: ChartPlot[]
}
/**
 * Creates a canvas element of a line chart for use elsewhere
 * @returns
 */
export const PerformanceChartLite: React.FC<Props> = ({ data }) => {
  try {
    const [ref] = useChartJS<number>(getPerformanceLineConfig(data), [0])

    if (ref === null) {
      return null
    }
    return <canvas ref={ref} width="18" height="18" />
  } catch {
    console.warn('Failed to render PerformanceChartLite')
    return null
  }
}
